import { INVOICE_ORIGINS, INVOICE_STATUSES } from "../types/invoices.types.ts"

const LOCKED_STATUSES: number[] = [
  INVOICE_STATUSES.ISSUED,
  INVOICE_STATUSES.PARTIALLY_PAID,
  INVOICE_STATUSES.PAID,
  INVOICE_STATUSES.VOID
]

interface LockableInvoice {
  status?: number | null
  origin?: number | null
  is_locked?: boolean
}

/**
 * An invoice in the lifecycle proper is an immutable document — corrections go
 * through void + reissue.
 *
 * `status` arrives overwritten with the derived OVERDUE on any past-due row, so
 * the stored status is not recoverable here and the server's flag is the only
 * reliable signal. The fallback covers payloads from a backend that predates
 * the field; it locks generated rows on origin (unaffected by the OVERDUE
 * rewrite) and external ones on status, which is wrong only while a past-due
 * external invoice is rendered against an old backend.
 */
export const isInvoiceLocked = (record?: LockableInvoice | null): boolean => {
  if (!record) return false
  if (typeof record.is_locked === "boolean") return record.is_locked
  return (
    (record.origin === INVOICE_ORIGINS.GENERATED &&
      record.status !== INVOICE_STATUSES.DRAFT) ||
    LOCKED_STATUSES.includes(record.status ?? -1)
  )
}
